import React from "react";
import { Link, LinkProps } from "react-router-dom";
import { H } from "highlight.run";

interface TrackLinkProps extends LinkProps {
  event: string;
  metadata?: Record<string, any>;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const track = (event: string, metadata?: Record<string, any>) => {
  H.track(event, metadata);
};

export const TrackLink: React.FC<TrackLinkProps> = ({ onClick, ...props }) => {
  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    if (onClick) {
      onClick(event);
    }

    track(props.event, props.metadata);
  };

  return <Link {...props} onClick={handleClick} />;
};

interface TrackButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  event: string;
  metadata?: Record<string, any>;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const TrackButton: React.FC<TrackButtonProps> = ({
  onClick,
  ...props
}) => {
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    if (onClick) {
      onClick(event);
    }

    track(props.event, props.metadata);
  };

  return <button {...props} onClick={handleClick} />;
};
